var map = {
	"./Combined Shape.svg": [
		5108,
		5108
	],
	"./add.svg": [
		28371,
		8371
	],
	"./addPerson.svg": [
		16716,
		6716
	],
	"./alert.svg": [
		10192,
		192
	],
	"./archive.svg": [
		57752,
		5371
	],
	"./arrow-right.svg": [
		16876,
		6876
	],
	"./bank.svg": [
		66500,
		6500
	],
	"./bankid.svg": [
		94307,
		4307
	],
	"./barista.svg": [
		48312,
		8312
	],
	"./bartender.svg": [
		20087,
		87
	],
	"./bell.svg": [
		20333,
		333
	],
	"./calendar.svg": [
		83300,
		3300
	],
	"./camera.svg": [
		96827,
		6827
	],
	"./card.svg": [
		37752,
		7752
	],
	"./cashier.svg": [
		14433,
		4433
	],
	"./chat.svg": [
		81244,
		1244
	],
	"./checkmark.svg": [
		91033,
		1033
	],
	"./chef.svg": [
		62586,
		2586
	],
	"./chevron-down.svg": [
		52764,
		2764
	],
	"./chevron-left.svg": [
		75211,
		5211
	],
	"./chevron-right.svg": [
		70734,
		734
	],
	"./chevron-up.svg": [
		10135,
		135
	],
	"./clock.svg": [
		25980,
		5980
	],
	"./clone.svg": [
		82165,
		2165
	],
	"./company.svg": [
		33779,
		3779
	],
	"./cross.svg": [
		87102,
		7102
	],
	"./day.svg": [
		59920,
		9920
	],
	"./dishwasher.svg": [
		45702,
		5702
	],
	"./document.svg": [
		36077,
		6077
	],
	"./doorman.svg": [
		68670,
		8670
	],
	"./download.svg": [
		88782,
		8782
	],
	"./downward_arrow.svg": [
		63806,
		3806
	],
	"./duplicate.svg": [
		15697,
		5697
	],
	"./eye.svg": [
		97057,
		7057
	],
	"./favorites-active.svg": [
		54792,
		4792
	],
	"./favorites-inactive.svg": [
		86753,
		6753
	],
	"./filter.svg": [
		97148,
		7148
	],
	"./group.svg": [
		59535,
		9535
	],
	"./hamburger.svg": [
		73183,
		3183
	],
	"./home-cleaning.svg": [
		20517,
		517
	],
	"./hotel-cleaning.svg": [
		17496,
		7496
	],
	"./idbadge.svg": [
		97466,
		7466
	],
	"./image.svg": [
		70741,
		741
	],
	"./kitchen.svg": [
		83398,
		3398
	],
	"./letter.svg": [
		84186,
		4186
	],
	"./list.svg": [
		41530,
		1530
	],
	"./lock.svg": [
		1287,
		1287
	],
	"./logout.svg": [
		88908,
		8908
	],
	"./mail.svg": [
		54827,
		4827
	],
	"./message.svg": [
		73379,
		5760
	],
	"./minus.svg": [
		28026,
		8026
	],
	"./minus_old.svg": [
		61156,
		1156
	],
	"./overflow.svg": [
		34104,
		4104
	],
	"./paginationArrowLeft.svg": [
		92098,
		2098
	],
	"./paginationArrowRight.svg": [
		60441,
		441
	],
	"./pen.svg": [
		43999,
		3999
	],
	"./person.svg": [
		23325,
		3325
	],
	"./phone.svg": [
		3998,
		3998
	],
	"./pin.svg": [
		26099,
		6099
	],
	"./play.svg": [
		34668,
		4668
	],
	"./plus.svg": [
		38546,
		8546
	],
	"./plus_old.svg": [
		75948,
		5948
	],
	"./preparation.svg": [
		2773,
		2773
	],
	"./question.svg": [
		1238,
		1238
	],
	"./receipt.svg": [
		57222,
		7222
	],
	"./receptionist.svg": [
		10979,
		979
	],
	"./reload.svg": [
		14261,
		4261
	],
	"./search.svg": [
		7622,
		7622
	],
	"./security-guard.svg": [
		39616,
		9616
	],
	"./settings.svg": [
		87733,
		7733
	],
	"./share.svg": [
		8051,
		8051
	],
	"./star-filled.svg": [
		73859,
		3859
	],
	"./star.svg": [
		41817,
		4198
	],
	"./trashcan.svg": [
		43126,
		3126
	],
	"./upward_arrow.svg": [
		46697,
		6697
	],
	"./user-minus.svg": [
		86016,
		6016
	],
	"./v2/absent.svg": [
		66482,
		6482
	],
	"./v2/bank.svg": [
		27303,
		7303
	],
	"./v2/calendar.svg": [
		23668,
		3668
	],
	"./v2/chart.svg": [
		25923,
		5923
	],
	"./v2/chat.svg": [
		71131,
		1131
	],
	"./v2/checkmark.svg": [
		23652,
		3652
	],
	"./v2/clock.svg": [
		30617,
		617
	],
	"./v2/cross-person.svg": [
		44015,
		4015
	],
	"./v2/cross.svg": [
		11831,
		1831
	],
	"./v2/document.svg": [
		17030,
		7030
	],
	"./v2/dollar_circle.svg": [
		4726,
		4726
	],
	"./v2/down-chevron.svg": [
		65479,
		5479
	],
	"./v2/download.svg": [
		10857,
		857
	],
	"./v2/envelope.svg": [
		76801,
		6801
	],
	"./v2/expand-vertical.svg": [
		23612,
		3612
	],
	"./v2/eye.svg": [
		17072,
		7072
	],
	"./v2/globe.svg": [
		91244,
		8863
	],
	"./v2/info.svg": [
		63817,
		3817
	],
	"./v2/left-arrow.svg": [
		14278,
		4278
	],
	"./v2/left-chevron.svg": [
		452,
		452
	],
	"./v2/list.svg": [
		33045,
		3045
	],
	"./v2/logout.svg": [
		88571,
		8571
	],
	"./v2/menu.svg": [
		63216,
		3216
	],
	"./v2/minus-person.svg": [
		70951,
		951
	],
	"./v2/money.svg": [
		52127,
		2127
	],
	"./v2/monochrome-simflexity.svg": [
		97271,
		7271
	],
	"./v2/not-visible.svg": [
		97545,
		7545
	],
	"./v2/pen.svg": [
		85742,
		5742
	],
	"./v2/percent.svg": [
		55252,
		5252
	],
	"./v2/person.svg": [
		9758,
		9758
	],
	"./v2/picture.svg": [
		62629,
		2629
	],
	"./v2/plus-person.svg": [
		13093,
		3093
	],
	"./v2/plus.svg": [
		8833,
		8833
	],
	"./v2/reload.svg": [
		44594,
		4594
	],
	"./v2/reset.svg": [
		39978,
		9978
	],
	"./v2/right-arrow.svg": [
		87821,
		7821
	],
	"./v2/right-chevron.svg": [
		30983,
		983
	],
	"./v2/roster.svg": [
		6052,
		6052
	],
	"./v2/search.svg": [
		91645,
		1645
	],
	"./v2/send.svg": [
		82963,
		2963
	],
	"./v2/settings.svg": [
		81710,
		1710
	],
	"./v2/shift.svg": [
		32047,
		2047
	],
	"./v2/simflexity-logo.svg": [
		63379,
		3379
	],
	"./v2/simflexity.svg": [
		49053,
		9053
	],
	"./v2/small-checkmark.svg": [
		83802,
		3802
	],
	"./v2/star.svg": [
		33761,
		3761
	],
	"./v2/swish.svg": [
		91345,
		1345
	],
	"./v2/team.svg": [
		53434,
		3434
	],
	"./v2/transfer.svg": [
		43236,
		3236
	],
	"./v2/trash.svg": [
		92073,
		2073
	],
	"./v2/unreported.svg": [
		3577,
		3577
	],
	"./v2/up-chevron.svg": [
		71904,
		1904
	],
	"./v2/wallet.svg": [
		17574,
		7574
	],
	"./v2/warning-triangle.svg": [
		2504,
		2504
	],
	"./v2/white-simflexity.svg": [
		42365,
		2365
	],
	"./video.svg": [
		90371,
		371
	],
	"./wallet.svg": [
		54457,
		4457
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 25744;
module.exports = webpackAsyncContext;